module.exports = __webpack_public_path__ + "img/benin.8c2d849d.svg";